var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradientEllipsisPink = function SvgGradientEllipsisPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 271 272"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.59,
    cy: 135.682,
    r: 135.41,
    fill: "url(#gradient-ellipsis-pink_svg__a)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-ellipsis-pink_svg__a",
    x1: 169.259,
    x2: 85.817,
    y1: 80.054,
    y2: 257.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB008C",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A4A",
    stopOpacity: 0
  })))));
};
export default SvgGradientEllipsisPink;